// AlertContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { CircleCheck } from 'lucide-react';

const AlertContext = createContext();

export function AlertProvider({ children }) {
    const [message, setMessage] = useState(null);
    const [isMobile, setIsMobile] = useState(false);      // State to track if it's a mobile screen


    const showAlert = (msg) => {
        setMessage(msg);
        setTimeout(() => setMessage(null), 3000); // clear after 3s
    };


    useEffect(() => {
        // Function to detect mobile screen size
        const handleResize = () => {
            if (window.innerWidth <= 768) {
              setIsMobile(true);  // If width is less than or equal to 768px, set as mobile
            } else {
              setIsMobile(false); // Otherwise, it's not mobile
            }
          };
      
          handleResize();
          window.addEventListener('resize', handleResize);
      
          // Cleanup the event listener on component unmount
          return () => {
            window.removeEventListener('resize', handleResize);
          };
      
        }, []);

    return (
        <AlertContext.Provider value={{ showAlert }}>
            {children}
            {message && (
                <div style={{
                    position: 'fixed',
                    ...(isMobile ? { top: '20px' } : { bottom: '20px' }),
                    right: '20px',
                    padding: '10px 20px',
                    backgroundColor: '#85da9ae3',
                    color: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                    display:'flex',
                    flexDirection:'row',
                    alignItems:'center',
                    gap:'10px'
                }}>
                    <CircleCheck />
                    {message}
                </div>
            )}
        </AlertContext.Provider>
    );
}

export function useAlert() {
    return useContext(AlertContext);
}
